<template>
<!--  body    :class="[floatStatus == 'dark' ? 'dark' : 'body']"   -->
  <div class="body" :class="[status == 'true' ? 'dark' : 'body']">
    <header>
      <div class="title">
       <div class="title_left">
         瀚洋电信统一管理平台
       </div>
       <div class="title_right">
          <span class="username">{{ username }}</span>
<!--          <el-switch @change="floatBtn" v-model="status"/>-->
          <el-dropdown>
            <img class="clone" src="@/assets/clone.png" alt="">
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><div @click="logout()">登出</div></el-dropdown-item>
              <el-dropdown-item><div @click="changePassword()">修改密码</div></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
<!--          <div style="font-family: cursive;font-size: 18px" @click="logout()">登出</div>-->
<!--          <div style="font-family: cursive;font-size: 18px" @click="changePassword()">修改密码</div>-->
        </div>
      </div>
    </header>
    <div class="main">
      <el-tabs v-model="activeName" style="min-height: 100vh!important">
        <el-tab-pane name="1">
          <span style="font-size: 16px" slot="label"><i class="el-icon-house"></i> 首页</span>
          <div class="content_first">
            <home-page/>
          </div>
        </el-tab-pane>
        <el-tab-pane name="2" style="font-size: 16px" label="我的工作">
<!--          :floatStatus="floatStatus"-->
         <work/>
        </el-tab-pane>
      </el-tabs>
    </div>
    <footer>旧版入口： <a v-for="(item,index) in modelList" :key="index" :href="item.path">{{item.name}}</a></footer>
  </div>
</template>

<script>
import HomePage from './components/HomePage'
import Work from './components/Work'
import axios from 'axios'
// import imgUrlHYOA from '../assets/hanyangOA.png'
// import imgUrlHYHR from '../assets/hanyangHR.png'
import Welcome from './Welcome'

export default {
  name: 'home',
  components: {
    HomePage,
    Work
  },
  data () {
    const Authorization = JSON.parse(localStorage.getItem('Authorization'))
    return {
      modelList: [
      // 正式
        { name: '瀚洋oa', path: 'https://app.hanyangtelecom.com/hanyang-oa/a/sys/oatoken/check?token=' + Authorization.val },
        { name: '智慧人力', path: 'https://app.hanyangtelecom.com/hr/base/login?token=' + Authorization.val },
        { name: '瀚洋之音', path: 'https://app.hanyangtelecom.com/wechat/outside/' + Authorization.val }
      // 测试
        // { name: '瀚洋oa', path: 'http://58.34.191.202:8884/hyoa/a/sys/oatoken/check?token=' + Authorization.val },
        // { name: '智慧人力', path: 'http://58.34.191.202:8000/hr/base/login?token=' + Authorization.val },
        // { name: '瀚洋之音', path: 'http://58.34.191.202:8000/wechat/outside/' + Authorization.val }
      ],
      activeName: '1',
      status: false,
      username: ''
    }
  },
  created () {
    this.username = Welcome.methods.getLocalStorage('loginName')
    const activeName = this.$route.query.activeName
    if (activeName) {
      this.activeName = activeName
    } else {
      this.activeName = '1'
    }
    let message = this.$route.params.message
    if (message == null) {
    } else if (message === 'userNonexistent') {
      this.$router.push('/home')
      this.notificationWarning('子系统中该用户不存在')
    } else if (message === 'uncertificatedToken') {
      this.notificationWarning('登录状态已失效，请注销后重新登录')
      console.log('uncertificatedToken')
      this.$router.push('/home')
      top.location.href = 'https://app.hanyangtelecom.com'
    } else {
      this.$router.push('/home')
      this.notificationWarning(message)
    }
  },
  methods: {
    // 登出
    logout () {
      axios.delete('/logout/' + Welcome.methods.getLocalStorage('Authorization')).then(res => {
        localStorage.removeItem('Authorization')
        this.$router.replace({})
        this.$router.push('/')
      }).catch(error => {
        this.notification('登出失败！  ' + error)
      })
    },
    // 修改密码
    changePassword () {
      this.$router.push('/ChangePassword/')
    },
    notificationWarning (msg) {
      const h = this.$createElement
      this.$message({
        message: h('i', {style: 'color: brown'}, msg),
        type: 'warning',
        center: true
      })
    },
    floatBtn () {
      this.status = true
      console.log(this.status)
      console.log(1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .body {
    header {
      width: 100%;
      height: 70px;
      line-height: 70px;
      background-color: #0a4b9d;

      .title {
        width: 80%;
        margin: 0 auto;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;

        .title_left {
          font-size: 35px;
          font-weight: 700;
          color: #fff;
          display: flex;
          align-items: center;
          font-family: cursive
        }

        .title_right {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .clone{
            width: 25px;
            height: 25px;
            position: fixed;
            top: 23px;
          }
          .clone:hover{
            width: 26px;
            height: 26px
          }
          div {
            font-size: 13px;
            color: #fff;
            margin-left: 20px;
          }
        }
      }
    }
    .main {
         width: 80%;
         margin: 0 auto;
      .content_first{
        width: 100%;
        background-color: white;
      }
     }
    footer{
      font-size: 14px;
      width: 100%;
      padding: 0 0 2% 0;
      text-align: center;
      a{
        padding: 0 8px;
        font-size: 14px;
        color: #4bb9e5;
      }
    }
    ::v-deep.body header .title .title_right div[data-v-7eb2bc79] {
      font-size: 13px;
      color: #fff;
      margin-left: 20px;
      line-height: 10px;
    }
  }
  .dark {
    background-color:#333;
    header {
      width: 100%;
      height: 70px;
      line-height: 70px;
      background-color: #0a4b9d;

      .title {
        width: 80%;
        margin: 0 auto;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;

        .title_left {
          font-size: 35px;
          font-weight: 700;
          color: #fff;
          display: flex;
          align-items: center;
          font-family: cursive
        }

        .title_right {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .clone{
            width: 25px;
            height: 25px;
          }
          .clone:hover{
            width: 26px;
            height: 26px
          }
          div {
            font-size: 13px;
            color: #fff;
            margin-left: 20px;

          }
        }
      }
    }
    .main {
      width: 80%;
      margin: 0 auto;
      .content_first{
        width: 100%;
        background-color: white;
      }
    }
    footer{
      font-size: 14px;
      width: 100%;
      padding: 0 0 2% 0;
      text-align: center;
      margin-top: 20px;
      a{
        padding: 0 8px;
        font-size: 14px;
        color: #fff;
      }
    }
  }
// 顶部用户名
.username{
  color: #fff;
  letter-spacing: 1px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue